/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_ManualInputs */

const en_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

const fr_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle`)
};

const de_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handbuch`)
};

const it_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuale`)
};

const ru_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководство`)
};

const es_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

const zh_cn2_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动的`)
};

const ja_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マニュアル`)
};

const hi_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नियमावली`)
};

const pt_pt2_segment_event_group_manual = /** @type {(inputs: Segment_Event_Group_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

/**
* | output |
* | --- |
* | "Manual" |
*
* @param {Segment_Event_Group_ManualInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_manual = /** @type {((inputs?: Segment_Event_Group_ManualInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_ManualInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_manual(inputs)
	if (locale === "de") return de_segment_event_group_manual(inputs)
	if (locale === "it") return it_segment_event_group_manual(inputs)
	if (locale === "ru") return ru_segment_event_group_manual(inputs)
	if (locale === "es") return es_segment_event_group_manual(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_manual(inputs)
	if (locale === "ja") return ja_segment_event_group_manual(inputs)
	if (locale === "hi") return hi_segment_event_group_manual(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_manual(inputs)
	return en_segment_event_group_manual(inputs)
});